import { log, supabase } from ".";
import { cambioRequiereRecaptura, capturarSnapshotDesdeVenta, traceSnapshot } from "./comisionSnapshot";

// Devuelve { data, snapshotFallo }: el update de la venta SIEMPRE se aplica; `snapshotFallo=true`
// avisa que la re-captura de la foto de comisión falló (el caller lo toastea). Nunca se traga en
// silencio (regla 10.177): además deja `traceSnapshot` para la red de seguridad.
export const updateOportunidad = async ({ id, oportunidad }) => {
  try {
    // Estado previo (para comparar sensibilidad y como base de la re-captura)
    let antes = null;
    try {
      const prev = await supabase.select("sales", { filters: { id } });
      antes = prev && prev[0];
    } catch (prevErr) {
      log.error("updateOportunidad/antes", prevErr);
    }

    const data = await supabase.update("sales", oportunidad, id);

    if (!data || data.length === 0) throw new Error("Empty response");

    // Re-captura ADITIVA: solo si cambió un campo sensible. Si falla, NO aborta el update, pero
    // NO es silenciosa: deja traza estructurada + flag para el toast del caller (10.177).
    let snapshotFallo = false;
    try {
      if (antes) {
        // Defensa en profundidad: fijar el `id` CONOCIDO (no depender del "antes")
        // → la foto nunca se mis-keyea aunque el "antes" viniera mal.
        const despues = { ...antes, ...oportunidad, id };
        if (cambioRequiereRecaptura(antes, despues)) {
          await capturarSnapshotDesdeVenta(despues, "modificacion");
        }
      }
    } catch (snapErr) {
      snapshotFallo = true;
      traceSnapshot("recaptura_edit_fallo", {
        origenTipo: "sale",
        saleId: id,
        error: String(snapErr?.message || snapErr),
      });
      log.error("updateOportunidad/snapshot", snapErr);
    }

    return { data, snapshotFallo };
  } catch (error) {
    log.error("updateOportunidad", error);
    throw error;
  }
};
